import React from "react"; // JSX

import HeroSlider, { Slide, Nav, OverlayContainer } from "hero-slider";
import { returnResizedImageURL } from "@accrosoft-ltd/accropress-websites-components/dist/esm/imgUtils";

var BasicSlider = function BasicSlider(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "banner home-banner"
  }, /*#__PURE__*/React.createElement(HeroSlider, {
    slidingAnimation: props.slidingAnimation || "left_to_right",
    orientation: props.orientation || "horizontal",
    initialSlide: props.initialSlide || 1,
    onBeforeChange: function onBeforeChange(previousSlide, nextSlide) {
      return props.onBeforeChangeFunction("onBeforeChange", previousSlide, nextSlide);
    },
    onChange: function onChange(nextSlide) {
      return props.onBeforeChangeFunction("onChange", nextSlide);
    },
    onAfterChange: function onAfterChange(nextSlide) {
      return props.onBeforeChangeFunction("onAfterChange", nextSlide);
    },
    style: {
      backgroundColor: "rgba(0, 0, 0, 0.33)"
    },
    settings: {
      slidingDuration: props.slidingDuration || 250,
      slidingDelay: props.slidingDelay || 100,
      shouldAutoplay: props.shouldAutoplay !== undefined ? props.shouldDisplayButtons : true,
      shouldDisplayButtons: props.shouldDisplayButtons !== undefined ? props.shouldDisplayButtons : true,
      autoplayDuration: props.autoplayDuration || 5000,
      height: props.height || "100vh"
    }
  }, props.OverlayContainer && /*#__PURE__*/React.createElement(OverlayContainer, null, props.OverlayContainer), props.slides && props.slides.map(function (slide, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Slide, {
      background: {
        backgroundImage: returnResizedImageURL({
          w: 1900
        }, slide.backgroundImage || slide.value || slide[0].backgroundImage || slide[0].value),
        backgroundAttachment: slide.backgroundAttachment || "fixed"
      }
    }));
  }), /*#__PURE__*/React.createElement(Nav, null)));
};

export default BasicSlider;